var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35983 6.2731C6.08092 6.42562 5.87139 6.58695 5.71098 6.73947C5.50145 6.50628 5.24133 6.05018 5.24133 5.7158C5.24133 5.28022 5.9104 4.5 8.51445 4.5C10.2312 4.5 11 5.34035 11 6.59721C11 8.08579 9.91185 9.2312 7.61561 9.37346C7.35549 11.2683 7.05636 11.5 6.17775 11.5C5.63873 11.5 5.21965 11.2976 5 10.9735C5.74855 10.0613 6.18786 7.87314 6.35694 6.2731H6.35983ZM7.76734 8.00513C8.78613 7.8834 9.16474 7.40677 9.16474 6.62801C9.16474 6.17191 8.89595 5.81699 8.35694 5.81699C8.22688 5.81699 8.09682 5.82726 7.97832 5.83752C7.91763 6.64854 7.82803 7.39797 7.76879 8.00513H7.76734Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.a71bfc2e35098eb3daec89f4775c5ae1.svg";
export { ForwardRef as ReactComponent };